/**
 * Build a Google Maps URL for a patient appointment row (coords or text search).
 * @param {object} item — normalized appointment from GET /app/appointments
 * @returns {string|null}
 */
export function appointmentMapsHref(item) {
  if (!item || typeof item !== "object") return null;
  const lat = Number(item.clinicLatitude);
  const lng = Number(item.clinicLongitude);
  if (Number.isFinite(lat) && Number.isFinite(lng)) {
    return `https://www.google.com/maps/search/?api=1&query=${lat}%2C${lng}`;
  }
  const addr = String(item.clinicAddress || "").trim();
  const name = String(item.clinicName || "").trim();
  const q = [addr, name].filter(Boolean).join(" — ") || name || addr;
  if (!q) return null;
  return `https://www.google.com/maps/search/?api=1&query=${encodeURIComponent(q)}`;
}

/**
 * @param {string} phoneRaw
 * @returns {string|null} tel: href or null if not enough digits
 */
export function appointmentTelHref(phoneRaw) {
  const raw = String(phoneRaw || "").trim();
  if (!raw) return null;
  const digits = raw.replace(/\D/g, "");
  if (digits.length < 7) return null;
  return `tel:${digits}`;
}
